import type { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/srcV2/components/Header';

const Layout: FC<PropsWithChildren> = ({ children }) => {
	return (
		<main
			className="creator-theme flex min-h-svh w-full flex-col bg-white px-5 min-h-0 sm:h-full sm:px-6 md:px-8 xl:px-16"
			id="mini-creator-container"
		>
			<Header className="mb-5 shrink-0" />
			<div className="flex-1 min-h-0 flex justify-center">
				{children ?? <Outlet />}
			</div>
		</main>
	);
};

export default Layout;
